// Services
// export { CustomersService } from './fake/customers.service'; // You have to comment this, when your real back-end is done
export { WarehouseService } from './warehouse.service'; // You have to uncomment this, when your real back-end is done
